import * as types from './actionTypes';

export const showLoadingIndicator = () => ({
    type: types.showLoadingIndicator
});

export const hideLoadingIndicator = () => ({
    type: types.hideLoadingIndicator
});